<template>
  <div class="content-page">
    <div class="bd">
      <div class="" v-for="ele in list" :key="ele.id">
        <p class="title">{{ ele.typeName }}</p>
        <p class="typeExplain">{{ ele.typeExplain }}</p>
        <div class="comprehensive-stamps">
          <div
            class="comprehensiveStamps"
            @click="chooseCoupon(item)"
            v-for="item in ele.comprehensiveStampsList"
            :key="item.id"
          >
            <div class="img">
              <img :src="item.imgUrl" />
            </div>
            <div class="couponExplain">
              <div class="title">{{ item.title }}</div>
              <div class="title1">
                {{ item.subTitle }}
              </div>
              <div v-show="item.subTitle.length > 32" class="triangle-up"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="goBack">
        <el-button type="primary" size="small" @click="goBack">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      list: [],
      isOpen: false,
      checkId: "",
    };
  },
  computed: {
    ...mapState({
      isOwn: (state) => state.isOwn,
      oemInfo: (state) => state.oemInfo,
      shopInfo: (state) => state.shopInfo,
    }),
  },
  mounted() {
    let baseList = [
      {
        id: 1,
        typeName: "综合券",
        typeExplain: "",
        comprehensiveStampsList: [
          {
            id: 0,
            imgUrl: require("@/assets/img/couponList/generalVouchers.png"),
            title: "普通抵用券",
            subTitle: "普通抵用券、普通抵用券",
            isOpen: false,
          },
          {
            id: 2,
            imgUrl: require("@/assets/img/couponList/affiliateCoupon.png"),
            title: " 联盟优惠券",
            subTitle: "联盟优惠券、联盟优惠券",
            isOpen: false,
          },
        ],
      },
      {
        id: 2,
        typeName: "支付宝代金券",
        typeExplain:
          "注意：顾客使用支付宝付款时可直接核销。会与商户券叠加，请了解后使用。以财务账单对账为准，本页面不做统计",
        comprehensiveStampsList: [
          {
            id: 10,
            imgUrl: require("@/assets/img/couponList/alipayCoupon.png"),
            title: "支付宝API制券",
            subTitle: "使用支付宝API进行制券",
            isOpen: false,
          },
          {
            id: 11,
            imgUrl: require("@/assets/img/couponList/alipayScanCoupon.png"),
            title: " 支付宝扫码领券",
            subTitle:
              "《顾客拉新》返回的微信支付代金券二维码可用于线下地推，或者朋友圈推广，群内发布。促进二次消费",
            isOpen: true,
          },
          {
            id: 12,
            imgUrl: require("@/assets/img/couponList/alipayGift.png"),
            title: "支付宝支付有礼",
            subTitle:
              "《促进二次消费》顾客在支付宝支付后将显示代金券，顾客可直接领取，促进二次消费",
            isOpen: true,
          },
          // {
          //   id: 13,
          //   imgUrl: require("@/assets/img/couponList/alipayFreeSpread.png"),
          //   title: "支付宝其他途径免费推广 ",
          //   subTitle:
          //     "《顾客拉新》选择此渠道后，将在支付宝内自动匹配其他合适途径为您推广",
          //   isOpen: true,
          // },
        ],
      },
      // {
      //   id: 3,
      //   typeName: "微信支付代金券",
      //   typeExplain:
      //     "注意：顾客使用微信付款时可直接核销。会与商户券叠加，请了解后使用。以财务账单对账为准，本页面不做统计。",
      //   comprehensiveStampsList: [
      //     {
      //       id: 20,
      //       imgUrl: require("@/assets/img/couponList/weChatCoupon.png"),
      //       title: "微信支付API制券",
      //       subTitle: "使用微信支付API进行制券",
      //       isOpen: false,
      //     },
      //     {
      //       id: 21,
      //       imgUrl: require("@/assets/img/couponList/weChatScanCoupon.png"),
      //       title: " 微信支付扫码领券",
      //       subTitle:
      //         "《顾客拉新》返回的二维码可用于微信支付代金券线下地推，或者朋友圈推广，群内发布。促进二次消费",
      //       isOpen: true,
      //     },
      //     {
      //       id: 22,
      //       imgUrl: require("@/assets/img/couponList/weChatGift.png"),
      //       title: " 微信支付支付有礼",
      //       subTitle:
      //         "《促进二次消费》顾客在微信支付支付后将显示代金券，顾客可直接领取，促进二次消费",
      //       isOpen: true,
      //     },
      //     // {
      //     //   id: 23,
      //     //   imgUrl: require("@/assets/img/couponList/weChatNearByCoupon.png"),
      //     //   title: "微信支付附近发券 ",
      //     //   subTitle:
      //     //     "《促进二次消费》顾客在微信支付支付后将显示代金券，顾客可直接领取，促进二次消费",
      //     //   isOpen: true,
      //     // },
      //     {
      //       id: 24,
      //       imgUrl: require("@/assets/img/couponList/weChatPaysTheCoupon.png"),
      //       title: " 微信支付配额发券",
      //       subTitle:
      //         "《顾客拉新》与附近发券功能一致，需要有配额才可，配额需要核销代金券获得",
      //       isOpen: true,
      //     },
      //     // { id: 25, imgUrl: require('@/assets/img/couponList/weChatCircleOfFriends.png'), title: "  微信支付朋友圈发券", subTitle: "《顾客拉新》朋友圈发券是微信支付官方推出的营销工具，根据商户经营需求，智能为其定制代金券营销方案，代金券可在微信社交渠道中投放，包括但不限于朋友圈、公众号。用户领取代金券后，到店使用微信支付时自动核销，推广效果闭环，为商户带来营业额和品牌提升。注意：上个月线下交易笔数要求，商户行业以零售和餐饮行业为主", isOpen: true }
      //   ],
      // },
    ];
    if (this.isOwn || (!this.isOwn && this.oemInfo && this.oemInfo.isOpenBdmOem)) {
      baseList[0].comprehensiveStampsList.push(
        ...[
          {
            id: 29,
            imgUrl: require("@/assets/img/couponList/generalVouchers.png"),
            title: "无门槛云推赠送券",
            subTitle: "《顾客拉新，门店引流》顾客可通过云推码视频推广活动可以领取此券",
            isOpen: true,
          },
          {
            id: 30,
            imgUrl: require("@/assets/img/couponList/generalVouchers.png"),
            title: "普通云推满减券",
            subTitle: "《顾客拉新，门店引流》顾客可通过云推码视频推广活动可以领取此券",
            isOpen: true,
          },
        ]
      );
      baseList[1].comprehensiveStampsList.push({
        id: 16,
        imgUrl: require("@/assets/img/couponList/alipayFreeSpread.png"),
        title: "支付宝云推码券 ",
        subTitle: "《顾客拉新，门店引流》顾客可通过云推码视频推广活动可以领取此券",
        isOpen: true,
      });
      // baseList[2].comprehensiveStampsList.push({
      //   id: 26,
      //   imgUrl: require("@/assets/img/couponList/weChatPaysTheCoupon.png"),
      //   title: " 微信支付云推码券",
      //   subTitle: "《顾客拉新，门店引流》顾客可通过云推码视频推广活动可以领取此券",
      //   isOpen: true,
      // });
    }
    if (this.isOwn && this.shopInfo.edcShopType == 14) {
      baseList[0].comprehensiveStampsList.push({
        id: 3,
        imgUrl: require("@/assets/img/couponList/generalVouchers.png"),
        title: "停车券",
        subTitle: "停车券",
        isOpen: true,
      });
    }
    this.list = baseList;
  },
  methods: {
    chooseCoupon(item) {
      console.log(item, "chooseCoupon");
      localStorage.setItem("chooseCoupon", JSON.stringify(item));
      this.goBack();
    },
    goBack() {
      this.$router.push("/cardCoupon");
    },
  },
};
</script>

<style lang="less" scoped>
.goBack {
  text-align: center;
}
.bd {
  height: 100%;
  background: #fafafa;
  padding: 20px 0 0 20px;
  .title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #303133;
    position: relative;
  }
  .typeExplain {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #f56c6c;
    line-height: 40px;
  }
  .title1 {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-top: 10px;
  }
  .subTitle {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    width: 200px;
  }
  .comprehensive-stamps {
    display: flex;
    flex-wrap: wrap;
    cursor: pointer;
    .comprehensiveStamps {
      width: 318px;
      min-height: 106px;
      height: 126px;
      background: #fff;
      box-shadow: 2px 3px 9px 0px rgba(0, 0, 0, 0.02);
      border-radius: 10px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      padding: 35px 20px 0;
      box-sizing: border-box;
      margin: 20px 10px;
      position: relative;
      &:hover {
        .title1 {
          overflow: visible;
          text-overflow: none;
          display: block;
          -webkit-line-clamp: 99;
          -webkit-box-orient: vertical;
        }
        .triangle-up {
          transform: rotate(135deg);
        }
      }
      &:first-child {
        margin-left: 0;
      }
      .img {
        width: 48px;
        height: 48px;
      }
      .couponExplain {
        min-height: 60px;
        padding-left: 20px;
        box-sizing: border-box;
      }
      .triangle-up {
        width: 8px;
        height: 8px;
        transform: rotate(-45deg);
        border-top: 1px solid #999;
        border-right: 1px solid #999;
        position: absolute;
        right: 11px;
        bottom: 35px;
        transition: all 0.5s;
      }
      .triangle-down {
        width: 8px;
        height: 8px;
        transform: rotate(136deg);
        border-top: 1px solid #999;
        border-right: 1px solid #999;
        position: absolute;
        right: 11px;
        bottom: 35px;
      }
    }
  }
}
</style>
